import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import Card from '../components/ui/Card';
import Spinner from '../components/ui/Spinner';
import { useAuth } from '../context/AuthContext';
import { parseApiError } from '../utils/apiError';

// Email-verification landing. Reads the token from ?token= and posts to
// /api/auth/verifyEmail on mount. The token also comes back as
// devVerificationToken in non-prod (see RegisterModal).
export default function VerifyEmail() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [status, setStatus] = useState('verifying'); // verifying | done | error
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    if (!token) {
      setFormError('This verification link is missing its token. Request a new link from the log-in dialog.');
      setStatus('error');
      return undefined;
    }

    let active = true;
    (async () => {
      try {
        await verifyEmail(token);
        if (active) setStatus('done');
      } catch (err) {
        if (active) {
          const { formError: fe } = parseApiError(err);
          setFormError(fe);
          setStatus('error');
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [token, verifyEmail]);

  return (
    <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-7)', maxWidth: 480 }}>
      <h1>Verify email</h1>
      <Card style={{ marginTop: 'var(--ss-space-4)' }}>
        {status === 'verifying' && <Spinner label="Verifying" />}
        {status === 'done' && (
          <div className="ss-form">
            <p className="ss-form__success">
              Your email has been verified. You can now log in.
            </p>
            <Link className="ss-btn ss-btn--primary" to="/">Back home</Link>
          </div>
        )}
        {status === 'error' && (
          <div className="ss-form">
            <p className="ss-form__error" role="alert">{formError}</p>
            <Link className="ss-btn ss-btn--ghost" to="/">Back home</Link>
          </div>
        )}
      </Card>
    </section>
  );
}
